<div class="debug-fab">
    @if (open()) {
        <div class="debug-fab__panel">
            <div class="debug-fab__panel-header">
                <span class="debug-fab__panel-title">Debug</span>
                <span class="debug-fab__env-badge">{{ apiUrlOptions.length > 1 ? 'local' : 'dev' }}</span>
            </div>
            <div class="debug-fab__panel-body">
                <label class="debug-fab__label" for="debug-api-url">API URL</label>
                <select cSelect size="sm" id="debug-api-url"
                        [ngModel]="apiUrl"
                        (ngModelChange)="setApiUrl($event)">
                    @for (opt of apiUrlOptions; track opt) {
                        <option [value]="opt">{{ opt }}</option>
                    }
                </select>

                <label class="debug-fab__label mt-2" for="debug-theme">Theme</label>
                <select cSelect size="sm" id="debug-theme"
                        [ngModel]="theme"
                        (ngModelChange)="setTheme($event)">
                    @for (opt of themeOptions; track opt.value) {
                        <option [value]="opt.value">{{ opt.label }}</option>
                    }
                </select>
            </div>
        </div>
    }
    <button class="debug-fab__btn" type="button" title="Debug menu" (click)="toggle()">
        🐞
    </button>
</div>
